export default "__VITE_ASSET__EzuhmC3U__"